import Cookies from 'js-cookie';
import { Duration } from 'luxon';
import * as Sentry from '@sentry/browser';
import { fadingMessage } from './puzzle';
export default {
  props: {
    clueData: {
      required: true,
      type: Object
    }
  },
  computed: {
    none() {
      return this.clueData.hints.size === 0 && this.clueData.unlocks.size === 0 ? 'None yet' : '';
    },
    sortedHints() {
      return this.hintArray(this.clueData.hints);
    },
    sortedUnlocks() {
      const t = this;
      let ordered = [];
      let failures = [];
      for (const id of t.clueData.unlockOrder) {
        if (t.clueData.unlocks.has(id)) {
          const u = t.clueData.unlocks.get(id);
          ordered.push([id, {
            unlock: u.unlock,
            guesses: u.guesses,
            isNew: u.isNew,
            hints: t.hintArray(u.hints)
          }]);
        } else {
          failures.push(id);
        }
      }
      if (failures.length > 0) {
        Sentry.withScope(function (scope) {
          scope.setExtras({
            order: t.clueData.unlockOrder,
            unlocks: Object.fromEntries(t.clueData.unlocks)
          });
          Sentry.captureMessage('Unlocks in order not present');
        });
      }
      return ordered;
    }
  },
  methods: {
    durationString(value) {
      return Duration.fromISO(value).toFormat('hh:mm:ss');
    },
    hintArray(hintMap) {
      return Array.from(hintMap.entries()).sort((a, b) => a[1].time.localeCompare(b[1].time));
    },
    acceptHint(hintId, unlockId) {
      fetch('accept_hint', {
        method: 'POST',
        body: new URLSearchParams({
          id: hintId.toString()
        }),
        headers: {
          'X-CSRFToken': Cookies.get('csrftoken')
        }
      }).then(res => res.json()).then(data => {
        if ('error' in data) {
          console.log('Server returned error when trying to accept the hint.', data.error);
          fadingMessage(document.querySelector('#hints'), 'Server returned error when trying to accept the hint.', data.error);
          return;
        }
        let hintData;
        if (unlockId === null) {
          hintData = this.clueData.hints.get(hintId);
        } else {
          hintData = this.clueData.unlocks.get(unlockId).hints.get(hintId);
        }
        // if the response arrives before the websocket message, display a holding message
        if (!hintData.accepted) {
          hintData.accepted = true;
          hintData.hint = '<i>getting hint...</i>';
        }
      }).catch(err => {
        console.log('There was an error accepting the hint.', err);
        fadingMessage(document.querySelector('#hints'), 'There was an error accepting the hint.', err);
      });
    }
  }
};